import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { Hub, Logger } from 'aws-amplify';
import * as moment from 'moment';
import {
  APIService,
  CreateTokensInput,
  GetTokensQuery,
} from 'src/app/API.service';
import { v4 as uuidv4 } from 'uuid';
import { UserBillingStatus } from 'src/app/doc2txt/utils/userBillingStatus';
import { HttpClient } from '@angular/common/http';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
/** Subscription type will be inferred from this library */
import { ZenObservable } from 'zen-observable-ts';

@Component({
  selector: 'app-user-page',
  templateUrl: './user-page.component.html',
  styleUrls: ['./user-page.component.css'],
})
export class UserPageComponent {
  /** Declare subscription variable */
  private subscription: ZenObservable.Subscription | null = null;

  loadingFlag = true;
  activeTab: string;
  tokenType: string = 'subscription';
  userBillingStatus: UserBillingStatus;
  favoriteSeason: string;
  seasons: string[] = ['Winter', 'Spring', 'Summer', 'Autumn'];
  updatePaymentInterval: NodeJS.Timer;

  constructor(
    private api: APIService,
    private http: HttpClient,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.activeTab = 'ngb-panel-1';
  }
  user: any;
  authListen: (data: any) => void;
  token: GetTokensQuery | null;

  async ngOnInit() {
    this.authListen = this.authListener();
    Hub.listen('auth', this.authListen);

    this.user = await Auth.currentUserInfo();
    if (!this.user) {
      this.loadingFlag = false;
    } else {
      await this.getTokenAndCalc();
    }

    this.loadingFlag = false;

    /* subscribe to update */
    this.subscription = this.api
      .OnUpdateSumitPaymentListener()
      .subscribe((event: any) => {
        this.loadingFlag = true;
        setTimeout(async () => {
          await this.getTokenAndCalc();

          this.loadingFlag = false;
        }, 1000);
      });

    this.subscription = this.api
      .OnUpdateTokensListener()
      .subscribe(async (event: any) => {
        this.token = event.value.data.onUpdateTokens;
        const tokenType = this.token?.type ?? '';
        this.tokenType = tokenType;
        await this.calcUserBillingStatus();
      });
  }

  private async getTokenAndCalc() {
    const token = await this.api.GetTokens(this.user.username);
    if (token) {
      this.token = token;
      const tokenType = this.token?.type ?? '';
      this.tokenType = tokenType;
      await this.calcUserBillingStatus();
    } else {
      const tokenInput: CreateTokensInput = {
        id: this.user.username,
        name: this.user.attributes.email,
        date: new Date().toISOString().substring(0, 10),
        enable: true,
        uuid: uuidv4(),
        month: 0,
        description: this.user.attributes.email,
        type: 'topUp',
        userExists: true,
        owner: this.user.username,
      };

      this.api
        .CreateTokens(tokenInput)
        .then((res) => {
          this.token = res;
        })
        .catch((e) => {
          console.log('error creating token...', JSON.stringify(e));
        });
    }
  }

  private async calcUserBillingStatus() {
    const userBillingStatus = new UserBillingStatus(
      this.api,
      this.http,
      this.token
    );
    this.userBillingStatus = userBillingStatus;

    if (this.token == null) return;
    await userBillingStatus.calcUserBillingStatus();
    if (userBillingStatus.sumitPayments.length > 0) {
      this.updatePaymentInterval = setInterval(async () => {
        await userBillingStatus.getPayments();
        if (userBillingStatus.sumitPayments.length == 0) {
          clearInterval(this.updatePaymentInterval);
          this.loadingFlag = true
          await userBillingStatus.calcUserBillingStatus();
          this.loadingFlag = false
        }
      },2000);
    }
  }

  openChangeTokenTypeModal(content) {
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-change-token-type' })
      .result.then(
        (result) => {
          if (this.token) {
            const tokenCleaned = JSON.parse(JSON.stringify(this.token));
            tokenCleaned.type = this.tokenType;
            delete tokenCleaned.__typename;
            delete tokenCleaned.createdAt;
            delete tokenCleaned.updatedAt;
            this.api.UpdateTokens(tokenCleaned).then((res) => {
              this.token = res;
            });
          }
        },
        (reason) => {
          this.tokenType = this.token?.type ?? '';
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  private authListener() {
    return async (data) => {
      switch (data.payload.event) {
        case 'configured':
          // logger.info('the Auth module is configured');
          break;
        case 'signIn':
          this.loadingFlag = true;

          this.user = await Auth.currentUserInfo();
          await this.getTokenAndCalc();
          this.loadingFlag = false;

          break;

        case 'signOut':
          this.user = null;
          // logger.info('user signed out');
          break;
      }
    };
  }
}
